import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import { SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import * as FullStory from '@fullstory/browser';

import App from './App';
import { themeConfig } from './config/mui/theme-config';
import client from './common/apollo/client';
import Snackbar from './common/components/snackbar/Snackbar';
import Zoom from './common/components/zoom/Zoom';
import { IntercomProvider } from 'react-use-intercom';

if (process.env.REACT_APP_ENV !== 'local') {
    Sentry.init({
        dsn: 'https://37919f665d7644d0af49f51c8d5f827d@o564534.ingest.sentry.io/6614996',
        integrations: [new BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        environment: process.env.REACT_APP_ENV,
    });
}

if (process.env.REACT_APP_ENV === 'production') {
    FullStory.init({
        orgId: 'o-1EP1EV-na1',
    });
}

ReactDOM.render(
    <ApolloProvider client={client}>
        <IntercomProvider appId={'rv18vbyq'}>
            <ThemeProvider theme={themeConfig}>
                <SnackbarProvider
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    Components={{
                        default: Snackbar,
                        success: Snackbar,
                        info: Snackbar,
                        error: Snackbar,
                        warning: Snackbar,
                    }}
                    preventDuplicate={true}
                    autoHideDuration={2000}
                    TransitionComponent={Zoom}
                    maxSnack={2}
                >
                    <BrowserRouter basename={'/c'}>
                        <App />
                    </BrowserRouter>
                </SnackbarProvider>
            </ThemeProvider>
        </IntercomProvider>
    </ApolloProvider>,
    document.getElementById('root'),
);
